var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWordpress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5755_3853",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5755_3853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.3675 40C7.3675 52.9437 14.8012 64.0944 25.655 69.3265L10.2602 26.7831C8.47187 30.9133 7.3675 35.3212 7.3675 40ZM62.0281 38.347C62.0281 34.357 60.5129 31.4595 59.2731 29.398C57.6201 26.643 56.1072 24.4414 56.1072 21.6887C56.1072 18.6606 58.449 15.9056 61.6172 15.9056H62.0305C56.245 10.5358 48.5358 7.3675 40 7.3675C34.5996 7.41531 29.2927 8.78259 24.5415 11.3503C19.7902 13.9179 15.7387 17.6082 12.7397 22.0996H14.806C18.2498 22.0996 23.4795 21.6864 23.4795 21.6864C25.2702 21.5486 25.408 24.1635 23.755 24.4414C23.755 24.4414 21.9642 24.7169 20.0381 24.7169L31.8799 59.9619L39.0381 38.6201L33.9437 24.7145L30.5 24.4437C28.7092 24.306 28.9847 21.6887 30.6377 21.6887C30.6377 21.6887 36.0053 22.102 39.1735 22.102C42.6173 22.102 47.847 21.6887 47.847 21.6887C49.6378 21.551 49.7755 24.1659 48.1225 24.4437C48.1225 24.4437 46.3317 24.7192 44.4056 24.7192L56.245 59.8313L59.57 48.9538C60.9475 44.4104 62.0471 41.2445 62.0471 38.3517L62.0281 38.347ZM40.551 42.8904L30.7755 71.255C33.6659 72.0815 36.8318 72.6325 40 72.6325C43.8546 72.6325 47.4337 71.92 50.8775 70.8418C50.7397 70.704 50.7398 70.5663 50.602 70.4285L40.551 42.8904ZM68.6378 24.4437L68.9132 27.7688C68.9132 31.0938 68.3623 34.7916 66.4361 39.4727L56.5229 68.2482C66.1606 62.6029 72.7679 52.1386 72.7679 40.0238C72.6301 34.3784 71.1149 29.1463 68.6354 24.4675L68.6378 24.4437ZM40 2C19.0715 2 2 19.0715 2 40C2 60.9285 19.0715 78 40 78C60.9285 78 78 60.9285 78 40C78 19.0715 60.9285 2 40 2ZM40 76.347C20.0357 76.347 3.79075 60.102 3.79075 40C3.80582 30.4013 7.62556 21.2001 14.4128 14.4128C21.2001 7.62556 30.4013 3.80582 40 3.79075C49.5987 3.80582 58.7999 7.62556 65.5872 14.4128C72.3744 21.2001 76.1942 30.4013 76.2093 40C76.2093 60.102 59.9643 76.347 40 76.347Z",
    fill: "#00749A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordpress);
export default __webpack_public_path__ + "static/media/Wordpress.15233a383ba831ac57efcbc0c9ae9d1e.svg";
export { ForwardRef as ReactComponent };